export const BUDGET_ASYNC_STORAGE_KEYS = {
  phone: 'budget-phone',
  cpf: 'budget-cpf',
  value: 'budget-value'
}
